import { useHeaders } from "hooks/api/useHeaders";
import { useMutation } from "react-query";
import { AssetType, uploadAssetReq } from "api/assets";
import { Asset, buildAssetViewModel } from "api/factories";

export const useUploadAsset = (
    assetType: AssetType,
    onSuccess: (data: Asset[], variables: { files: File[]; materialSpecId: number; materialId?: number }) => void
) => {
    const headers = useHeaders();

    return useMutation(
        ({ files, materialSpecId, materialId }: { files: File[]; materialSpecId: number; materialId?: number }) => {
            const formData = new FormData();
            formData.append("matspec", materialSpecId.toString());
            formData.append("type", assetType);

            if (materialId) {
                formData.append("admaterial", materialId.toString());
            }

            files.forEach((file) => {
                formData.append("file", file);
            });

            return buildAssetViewModel(uploadAssetReq(headers, formData));
        },
        {
            onSuccess,
        }
    );
};
